import Crud from '../views/Estoque/Crud'

let routes = {
    path: '/estoques',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        
        {
            path: '/estoques',
            name: 'list-estoques',
            component: Crud,
            meta: {
                pageTitle: 'Estoque',
                breadcrumb: [
                    {
                        text: 'Estoque',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
